<template>
  <div class="page-header">
    <Breadcrumb
      v-if="!hideBreadcrumb"
      v-bind="$attrs"
    />
    <h2 class="page-title">{{title}}</h2>
    <div v-if="pageDesc !== ''" class="sub-title">
      {{pageDesc}}
    </div>
  </div>
</template>

<script>
import Breadcrumb from '../Breadcrumb/Breadcrumb'
export default {
  name: 'PageHeader',
  components: { Breadcrumb },
  props: {
    hideBreadcrumb: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    pageDesc: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="less">
.page-header {
  width: 100%;
  height: auto;
  font-size: 20px;
  color: rgba(0,0,0,.85);
  flex: auto;
  background: #ffffff;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: flex-start;
  .page-title {
    font-size: 20px;
    font-weight: 500;
    color: rgba(0,0,0,.85);
    flex: auto;
    margin-top: 10px;
  }
  .sub-title {
    display: flex;
    width: 100%;
    flex: auto;
    font-size: 14px;
    line-height: 22px;
    color: rgba(0, 0, 0, 0.65);
  }
}

</style>
